module.exports = __webpack_public_path__ + "media/AI_welcome_B.254b884b.mp4";